// The Housify mark: three homes of rising height, like a portfolio growing
// (Sahil chose it 2026-10-23). The same drawing is public/icon.svg; the PNGs,
// favicon and maskable icons are rendered from it. One component so the
// sidebar, landing page, sign-in and company picker can never drift apart.
import React from "react";

export function BrandMark({ size = 32, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} role="img" aria-label="Housify">
      <defs>
        <linearGradient id="housify-mark-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#6d63ff" />
          <stop offset="1" stopColor="#3f37c9" />
        </linearGradient>
      </defs>
      <rect width="100" height="100" rx="24" fill="url(#housify-mark-g)" />
      <path d="M22 78V56L32 48L42 56V78Z" fill="#fff" fillOpacity=".7" />
      <path d="M40 78V44L52 34L64 44V78Z" fill="#fff" />
      <path d="M62 78V50L71 43L80 50V78Z" fill="#fff" fillOpacity=".85" />
      <rect x="47" y="60" width="10" height="18" rx="2" fill="#4f46e5" />
    </svg>
  );
}
